/* eslint-disable max-len */
import Vue from 'vue';
import Api from './BaseApi';
import { HTTP_EDOCSIGN } from '../plugins/axios';

class PerimetersConfApi extends Api {
  constructor(parameters = {}) {
    super(Vue.$http, 'perimeters', parameters);
    this.searchParameters = {};
  }

  /**
    * Method used to set the search parameters via an object.
    *
    * @param {Object} params The given parameter.
    *
    * @returns {Object} The instance of the OrganizationApi.
    */
  static setSearchParamObject(params) {
    this.searchParameters = params;
    return this;
  }

  /**
    * Method used to fetch all the perimeters from the API.
    *
    * @returns {Promise} The result in a promise.
    */
  static all() {
    let searchParameters = '';
    let offset = 0;
    let limit = 20;

    if (this.searchParameters !== undefined) {
      searchParameters = this.searchParameters.globalSearch;
      offset = `${this.searchParameters.offset}`;
      limit = this.searchParameters.limit;
    }
    return HTTP_EDOCSIGN.post('/configuration-perimeters/search',
      {
        orders: [
          {
            fieldName: 'name',
            orderBy: 'ASC',
          },
        ],
        params: [
          {
            paramName: 'token',
            paramValue: searchParameters,
          },
        ],
        offset,
        limit,
      },
    ).then(response => ({
      data: response.data.data.perimeters,
      pagination: {
        limit,
        totalCount: response.data.data.nbPerimeters,
        totalPages: Math.ceil(response.data.data.nbPerimeters / limit),
      },
    }));
  }


  /**
    * Method used to fetch all the options from the API.
    *
    * @returns {Promise} The result in a promise.
    */

  static allOptions() {
    return HTTP_EDOCSIGN.post('/options/liste')
      .then(response => response.data.data.options);
  }

  /**
    * Method used to create a perimeter.
    *
    * @param   {Object}  data Information about the name, description and options of the perimeter
    *
    * @returns {Promise} The result in a promise.
    */

  static create(data) {
    let options = {};
    options = Object.entries(data.option).map(([name, value]) => ({ name, value }));
    return HTTP_EDOCSIGN.post(
      '/configuration-perimeter/create',
      {
        name: data.name,
        description: data.description,
        options,
      },
    );
  }

  /**
    * Method used to update a perimeter.
    *
    * @param   {Object} data Information about the name, description and options of the perimeter
    *
    * @returns {Promise} The result in a promise.
    */

  static updatePerimeter(data) {
    let options = {};
    options = Object.entries(data.option).map(([name, value]) => ({ name, value }));
    return HTTP_EDOCSIGN.post(
      '/configuration-perimeter/update',
      {
        name: data.name,
        description: data.description,
        options,
      },
    );
  }

  /**
    * Method used to get all users.
    *
    * @returns {Promise} The result in a promise.
    */

  static allUsers() {
    let searchParameters = '';
    let offset = 0;
    const limit = 50;

    if (this.searchParameters !== undefined) {
      searchParameters = this.searchParameters.globalSearch;
      offset = `${this.searchParameters.offset}`;
    }

    return HTTP_EDOCSIGN.post('/accounts/searchMainUsers',
      {
        orders: [
          {
            fieldName: 'fullname',
            orderBy: 'ASC',
          },
        ],
        params: [
          {
            paramName: 'token',
            paramValue: searchParameters,
          },
        ],
        offset,
        limit,
      },
    ).then(response => ({
      data: response.data.data.accounts,
      pagination: {
        limit,
        totalCount: response.data.data.nbAccounts,
        totalPages: Math.ceil(response.data.data.nbAccounts / limit),
      },
    }));
  }

  /**
    * Method used to create a user.
    * @param   {Object}  data      Information about the name, description and options of the perimeter
    *
    * @returns {Promise} The result in a promise.
    */

  static createUser(data) {
    return HTTP_EDOCSIGN.post('/account/createMainUser',
      {
        login: data.user.login,
        password: data.user.password,
        firstname: data.user.firstname,
        lastname: data.user.lastname,
        email: data.user.email,
        town: data.user.town,
        postalCode: data.user.postalCode,
        address: data.user.address,
        mobilePhone: data.user.mobilePhone,
        service: data.user.service,
        entityType: data.user.entityType,
        logo: data.user.logo,
        edocCustomerRef: data.user.edocCustomerRef,
      },
    ).then(response => response.data.data.userId);
  }


  /**
    * Method used to update a user.
    *
    * @param   {String}  sessionId Token for edocSign
    * @param   {Object}  data      Information about the name, description and options of the perimeter
    *
    * @returns {Promise} The result in a promise.
    */

  static updateUser(data) {
    return HTTP_EDOCSIGN.post('/account/update',
      {
        userId: data.user.userId,
        login: data.user.login,
        password: data.user.password,
        firstname: data.user.firstname,
        lastname: data.user.lastname,
        email: data.user.email,
        town: data.user.town,
        postalCode: data.user.postalCode,
        address: data.user.address,
        mobilePhone: data.user.mobilePhone,
        service: data.user.service,
        entityType: data.user.entityType,
        edocCustomerRef: data.user.edocCustomerRef,
      },
    );
  }

  /**
    * Method used to link a user to a perimeter.
    *
    * @param   {Object}  data      Information about the name, description and options of the perimeter
    *
    * @returns {Promise} The result in a promise.
    */

  static AssignUser(userId, name) {
    return HTTP_EDOCSIGN.post('/configuration-perimeter/affectUser',
      {
        name,
        user: {
          userId,
        },
      },
    );
  }
}
export default PerimetersConfApi;



// WEBPACK FOOTER //
// ./src/api/PerimetersConfApi.js